<template>
  <div class="chat-bubble bot chips" :id="this.messageId + '-chips'" v-if="showChips">
    <div class="message px-0">
      <template :key="index" v-for="(chip, index) in this.chips">
        <button :id="this.messageId +'-chip-'+ index" type="button" class="mm-button chip"
          @click="clickChip(chip)"> {{ chip }}</button>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: [
    'chips',
    'messageId',
    'totalMessages'
  ],
  emits: ['selectChip'],
  methods: {
    clickChip(chipText) {
      this.$emit('selectChip', chipText);
    }
  },
  computed: {
    showChips() {
      return (this.messageId === 0 && this.totalMessages === 1) || (this.messageId === this.totalMessages);
    }
  }
}
</script>
